import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    padding: '40px',
    boxSizing: 'border-box',
  },

  bgImgContainer: {
    backgroundImage: "url(" + require('../../../assets/images/bdr_cv.jpg') + ")",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
    boxSizing: "border-box",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    backgroundPosition: "65% 0",
    backgroundSize: "auto 100vh",
  },

  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: "50px",
  },

  subTitle: {
    fontSize: '20px',
  },

  mainTitle: {
    fontSize: "60px",
    fontWeight: "bold",
  },

  mainTitleSmall: {
    fontSize: "40px",
  },

  cvContainer: {
    marginTop: "56px",
  },

  onlineMtgButton: {
    display: "block",
    flex: "1",
    width: "280px",
    height: "60px",
    padding: "unset",
    lineHeight: "4rem",
    textAlign: "center",
    borderRadius: "5px",
    background: "#CA9F20 0 0 no-repeat padding-box",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "18px",
    textDecoration: "none",
  }
});

class Promo extends React.Component {
  static TYPES = {
    "BDR": 1,
    "RECOMMEND": 2,
    "DEPARTMENT_TEL": 3,
    "INTENT_DATA": 4,
  };

  getRandomType = () => {
    const types = Object.values(Promo.TYPES);
    const randomIndex = Math.floor(Math.random() * types.length);
    return types[randomIndex];
  }

  initialState = {
    type: this.getRandomType(),
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  renderSubTitle() {
    if (this.state.type === Promo.TYPES.BDR) {
      return (<span>
        直通の部門電話番号・インテントデータから<br />
        レター&フォローコールによるアポイントの獲得まで
      </span>);
    } else if (this.state.type === Promo.TYPES.RECOMMEND) {
      return (<span>
        レター&コールの実績に基づいたターゲティング
      </span>);
    } else if (this.state.type === Promo.TYPES.DEPARTMENT_TEL) {
      return (<span>
        コールのコネクト率改善
      </span>);
    } else if (this.state.type === Promo.TYPES.INTENT_DATA) {
      return (<span>
        幅広い種類の興味関心キーワード
      </span>);
    }
  }

  renderMainTitle() {
    const { classes } = this.props;

    if (this.state.type === Promo.TYPES.BDR) {
      return (<span>
        Keyman Letter
        <br />
        <span className={classes.mainTitleSmall}>だから成功した</span>
        <br />
        BDR施策事例多数
      </span>);
    } else if (this.state.type === Promo.TYPES.RECOMMEND) {
      return (<span>
        20万件以上
        <span className={classes.mainTitleSmall}>の</span><br />
        <span className={classes.mainTitleSmall}>リアクションデータ元に</span>
        <br />キーマンをレコメンド
      </span>);
    } else if (this.state.type === Promo.TYPES.DEPARTMENT_TEL) {
      return (<span>
        キーマン<span className={classes.mainTitleSmall}>へ</span>直通<span className={classes.mainTitleSmall}>の</span>
        <br />
        部門電話番号<span className={classes.mainTitleSmall}>を</span>掲載
      </span>);
    } else if (this.state.type === Promo.TYPES.INTENT_DATA) {
      return (<span>
        20億件
        <span className={classes.mainTitleSmall}>の</span>
        インテントキーワード<span className={classes.mainTitleSmall}>を</span>毎日更新
      </span>);
    }
  }

  renderCvText() {
    if (this.state.type === Promo.TYPES.BDR) {
      return "施策事例を聞いてみる";
    } else if (this.state.type === Promo.TYPES.RECOMMEND) {
      return "活用事例を聞いてみる";
    } else if (this.state.type === Promo.TYPES.DEPARTMENT_TEL) {
      return "活用事例を聞いてみる";
    } else if (this.state.type === Promo.TYPES.INTENT_DATA) {
      return "活用事例を聞いてみる";
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div style={this.props.style}>
        <div className={classes.bgImgContainer}>
          <div className={classes.body}>
            <div className={classes.subTitle}>
              {this.renderSubTitle()}
            </div>
            <div className={classes.mainTitle}>
              {this.renderMainTitle()}
            </div>
            <div className={classes.cvContainer}>
              <a className={classes.onlineMtgButton} href={process.env.REACT_APP_SPIR_LINK_SOURCE_OTHER} target="_blank" rel="noopener noreferrer">
                {this.renderCvText()}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Promo.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
};

export default withStyles(styles)(Promo);



// WEBPACK FOOTER //
// ./src/components/Signin/sections/Promo.jsx